module.exports = __webpack_public_path__ + "static/media/part_placeholder.b0a0bc4a.png";